import { useEffect } from 'react'

/**
 * Custom hook for setting document title (seen in browser tab).
 * @param {string} title - The title of the document.
 */
export const useDocumentTitle = title => {
  useEffect(() => {
    document.title = title || 'Candidate - OfferZen'
  }, [title])
}
